__webpack_public_path__ = __webpack_public_path__.replace('{domain}', window.IOT && window.IOT.imgcache || '')

require('./init')
